namespace Portico.Models.Enterprise {

    import ent = Portico.Models.Enterprise;

    export interface IEnrollmentInput {
		defaultPaymentType: string;
		eligibility: EnrollmentVerification;
		isOptedIn: boolean;
		memberNumber: string;
    }

	export class EnrollmentInput implements IEnrollmentInput {
		defaultPaymentType: string;
		eligibility: EnrollmentVerification;
		isOptedIn: boolean;
		memberNumber: string;

		constructor(obj?: IEnrollmentInput) {
			this.defaultPaymentType = null;
			this.eligibility = null;
			this.isOptedIn = null;
			this.memberNumber = null;

            if (obj) {
				this.defaultPaymentType = obj.defaultPaymentType;

				if (obj.eligibility) {
					this.eligibility = new EnrollmentVerification(obj.eligibility);
				}

				this.isOptedIn = obj.isOptedIn;
				this.memberNumber = obj.memberNumber;
            }
        }
    }
}

